import 'whatwg-fetch'

import LazyLoad from 'vanilla-lazyload'
import gsap from 'gsap'
import { throttle, debounce } from 'throttle-debounce'

// Utils
import Menu from './util/Menu'
import DOMObserver from './util/DOMObserver'

// Routes
import Page from './routes/Page'

export default class App {

  /**
  * Loads the page
  * then calls `this.start()` when DOM is ready
  */
  constructor() {
    this.resize = this.resize.bind(this)
    this.scroll = this.scroll.bind(this)
    this.update = this.update.bind(this)

    this.raf = null

    this.resizeDebounced = debounce(100, this.resize)
    this.resizeThrottled = throttle(150, this.resize)
    this.scrollDebounced = debounce(100, this.scroll)
    this.scrollThrottled = throttle(50, this.scroll)

    this.checkMobile()
    this.start()
  }

  /**
  * Inits everything that is app-wide
  * ie: Menu, scroll / resize events...
  *
  * @returns {void}
  */
  start() {
    this.currentRenderer = new Page()
    this.menu = new Menu()
    this.lazyLoad = new LazyLoad()

    this.events()
    this.initDOMObserver()

    gsap.fromTo(document.querySelector('.app'), { opacity: 0 }, {
      opacity: 1,
      duration: 0.5,
      delay: 1,
      onStart: () => {
        requestAnimationFrame(this.update)
      }
    })
  }

  initDOMObserver() {
    this.DOMObserver = new DOMObserver(this.observerCallBack)
  }

  checkMobile() {
    App.isMobile && document.body.classList.remove('isMobile')
    App.isMobile && document.documentElement.classList.remove('isMobile')
    /* eslint-disable */
    App.isMobile = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    App.isMobile && document.body.classList.add('isMobile')
    App.isMobile && document.documentElement.classList.add('isMobile')
  }

  resize() {
    this.currentRenderer.resize()
    this.menu && this.menu.resize()
  }

  scroll() {
    this.currentRenderer.scroll()
    this.menu && this.menu.scroll()
  }

	update() {
		this.currentRenderer.update()
		this.raf = requestAnimationFrame(this.update)
	}

  events() {
    window.addEventListener('resize', this.resizeThrottled)
    window.addEventListener('resize', this.resizeDebounced)
    window.addEventListener('orientationchange', this.resize)
    window.addEventListener('scroll', this.scrollThrottled)
    window.addEventListener('scroll', this.scrollDebounced)
  }
}



// WEBPACK FOOTER //
// ./scripts/App.js